export default __webpack_public_path__ + "static/media/michel.e94ac429.png";